import { render, staticRenderFns } from "./CampaignsView.vue?vue&type=template&id=77df41e2&scoped=true"
import script from "./CampaignsView.vue?vue&type=script&lang=js"
export * from "./CampaignsView.vue?vue&type=script&lang=js"
import style0 from "./CampaignsView.vue?vue&type=style&index=0&id=77df41e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77df41e2",
  null
  
)

export default component.exports